import GeneralVehicleComponent from './general-vehicle-component';

export default GeneralVehicleComponent;
export { GeneralVehicleComponent };
